import { PlayerSide } from "../ai/TableAI";
import { CardSuit } from "../card/Card";

export function GetOppositeColorSuitToSuit(cardSuit: CardSuit): CardSuit
{
    switch(cardSuit) {
        case CardSuit.HEARTS: return CardSuit.DIAMONDS;
        case CardSuit.DIAMONDS: return CardSuit.HEARTS;
        case CardSuit.CLUBS: return CardSuit.SPADES;
        case CardSuit.SPADES: return CardSuit.CLUBS;
    }
}